import client from './client';

export const getModelList = (title) => client.get(`/fedops/api/model/${title}`);
